import { BaseService } from '@/modules/Core/services/BaseService'
import type { IAlertCondiciones } from '@/modules/Administracion/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces'

export class AlertCondicionesService extends BaseService<IAlertCondiciones> {
  constructor() {
    super({
      baseUrl: 'scheduling/alerts/condiciones/'
    })
  }

  /**
   * Obtener condiciones por ID de automatización
   */
  async getByAutomatizacionId(
    alauId: number
  ): Promise<AxiosResponse<IResponseApi<IAlertCondiciones[]>>> {
    return this.http.get(`automatizacion/${alauId}`)
  }

  /**
   * Crear o actualizar múltiples condiciones para una automatización
   */
  async saveCondicionesByAutomatizacion(
    alauId: number,
    condiciones: Partial<IAlertCondiciones>[]
  ): Promise<AxiosResponse<IResponseApi<IAlertCondiciones[]>>> {
    return this.http.post(`automatizacion/${alauId}/batch`, { condiciones })
  }

  /**
   * Eliminar todas las condiciones de una automatización
   */
  async deleteByAutomatizacionId(
    alauId: number
  ): Promise<AxiosResponse<IResponseApi<void>>> {
    return this.http.delete(`automatizacion/${alauId}`)
  }

  /**
   * Activar/desactivar una condición
   */
  async toggleActiva(
    alcoId: number,
    activa: boolean
  ): Promise<AxiosResponse<IResponseApi<IAlertCondiciones>>> {
    return this.http.patch(`${alcoId}/toggle`, { alcoActiva: activa })
  }
}